const escapeHtml = (value = '') =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

const formatPlainTextToHtml = (value = '') => {
  const normalized = String(value || '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .trim();

  if (!normalized) {
    return '<p>Dear colleague,</p><p>Thank you for your attention.</p>';
  }

  const paragraphs = normalized
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br />')}</p>`)
    .join('');

  return paragraphs || `<p>${escapeHtml(normalized).replace(/\n/g, '<br />')}</p>`;
};

export function buildEmailTemplate(templateName, subject, bodyContent = '') {
  const safeSubject = (subject || 'Message from RPSwiss').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const content = formatPlainTextToHtml(bodyContent);

  if (templateName === 'RPSwiss') {
    return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>${safeSubject}</title>
  </head>
  <body style="margin:0; background:#1B3047; color:#C9A84C; font-family:Arial, Helvetica, sans-serif;">
    <div style="max-width:760px; margin:0 auto; background:#1B3047; padding:32px 28px; box-sizing:border-box;">
      <div style="display:flex; justify-content:space-between; align-items:center; gap:16px; margin-bottom:24px;">
        <div style="font-size:28px; font-weight:700; letter-spacing:0.08em; color:#C9A84C;">RPSwiss</div>
        <img src="https://www.rpswiss.ch/img/rp_swiss_small.png" alt="RPSwiss logo" style="width:92px; height:auto; display:block; border-radius:8px;" />
      </div>
      <div style="background:#ffffff; color:#111827; border-radius:12px; padding:28px; line-height:1.7; border:1px solid rgba(201,168,76,0.4);">
        <h2 style="margin:0 0 16px; color:#1B3047; font-size:24px;">${safeSubject}</h2>
        ${content}
      </div>
    </div>
  </body>
</html>`;
  }

  if (templateName === 'ProfessionalsRegistration') {
    const safeName = escapeHtml(String(bodyContent || 'colleague').trim() || 'colleague');
    const professionalBody = `
      <p>Здравствуйте, ${safeName}!</p>
      <p>Спасибо, что зарегистрировались в качестве специалиста на RPSwiss.</p>
      <p>Мы рады приветствовать вас в нашем сообществе! Если у вас есть какие-либо вопросы, пожалуйста, свяжитесь с нами через веб-форму на сайте.</p>
      <p>С уважением,<br>Команда RPSwiss</p>
    `;

    return `<!DOCTYPE html>
<html lang="ru">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>${safeSubject}</title>
  </head>
  <body style="margin:0; background:#1B3047; color:#ffffff; font-family:Arial, Helvetica, sans-serif;">
    <div style="max-width:760px; margin:0 auto; background:#1B3047; padding:32px 28px; box-sizing:border-box;">
      <div style="display:flex; justify-content:space-between; align-items:center; gap:16px; margin-bottom:24px;">
        <div style="font-size:28px; font-weight:700; letter-spacing:0.08em; color:#C9A84C;">RPSwiss</div>
        <img src="https://www.rpswiss.ch/img/rp_swiss_small.png" alt="RPSwiss logo" style="width:92px; height:auto; display:block; border-radius:8px;" />
      </div>
      <div style="background:#ffffff; color:#111827; border-radius:12px; padding:28px; line-height:1.7; border:1px solid rgba(201,168,76,0.4);">
        <h2 style="margin:0 0 16px; color:#1B3047; font-size:24px;">${safeSubject}</h2>
        ${professionalBody}
      </div>
    </div>
  </body>
</html>`;
  }

  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>${safeSubject}</title>
  </head>
  <body style="margin:0; background:#f5f7fb; color:#1f2937; font-family:Arial, Helvetica, sans-serif;">
    <div style="max-width:760px; margin:0 auto; background:#ffffff; border:1px solid #e5e7eb; border-radius:12px; padding:28px; box-sizing:border-box; line-height:1.7;">
      <h2 style="margin:0 0 16px; font-size:24px; color:#111827;">${safeSubject}</h2>
      ${content}
    </div>
  </body>
</html>`;
}

export const EMAIL_TEMPLATE_OPTIONS = ['RPSwiss', 'Neutral', 'ProfessionalsRegistration'];
